import { Agent, AgentScope } from "~/services/agents";

// Duplicating an agent maps to the `can_duplicate` grant. Every caller who can
// see the agent holds it — editors and USER-level grants included (any non-null
// access_level), and SYSTEM agents confer it on everyone. Distinct from deleting
// (`can_delete`), which only owners hold.
export const useCanDuplicateAgent = (agent: Agent | undefined): boolean =>
  !!agent && (agent.scope === AgentScope.SYSTEM || agent.access_level !== null);
